<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
    >
        <path
            d="M11.58 4.08L8.8 6.86M8.8 6.86L6.03 4.08M8.8 6.86V0.750002M16.81 8.52H11.85V9.63C11.85 9.92439 11.7331 10.2067 11.5249 10.4149C11.3167 10.6231 11.0344 10.74 10.74 10.74H6.86C6.56561 10.74 6.28328 10.6231 6.07511 10.4149C5.86695 10.2067 5.75 9.92439 5.75 9.63V8.52H0.79M12.13 0.750002H12.28C12.7269 0.749389 13.1635 0.883646 13.5328 1.13521C13.9021 1.38678 14.187 1.74395 14.35 2.16L16.69 8.13C16.79 8.39 16.84 8.66 16.85 8.94V12.41C16.85 12.9988 16.6161 13.5634 16.1998 13.9798C15.7834 14.3961 15.2188 14.63 14.63 14.63H2.97C2.38122 14.63 1.81655 14.3961 1.40022 13.9798C0.983892 13.5634 0.75 12.9988 0.75 12.41V8.94C0.75 8.66 0.8 8.39 0.91 8.13L3.25 2.16C3.41304 1.74395 3.69785 1.38678 4.06717 1.13521C4.43649 0.883646 4.87314 0.749389 5.32 0.750002H5.47"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
